export default __webpack_public_path__ + "0de76ab497599dad114bb8057ea7ecbe.gif";